// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  mapboxKey: 'pk.eyJ1IjoicGhpc2l0a3VuIiwiYSI6ImNrbjhkdmdlMzAxY2cydW1nb3R1Njk2NzkifQ.Pxn2pQX_NCYB-bLjCJEdUw'
};
